import React, { useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { dienstleistungenSelector, serviceAnfrageByServiceUrlSelector } from '../../../../modules/selectors/standort/dienstleistungen';
import Select from '../../../components/form-elements/Select';
import Textarea from '../../../components/form-elements/Textarea';

const validationSchema = Yup.object().shape({ serviceNotes: Yup.string(), serviceUrl: Yup.string() });

function InactiveChildren({ values }) {
    const service = useSelector(state => serviceAnfrageByServiceUrlSelector(state, { serviceUrl: values.serviceUrl }));

    return (
        <>
            <dl className="uk-description-list">
                <dt>Ihre gewählte Serviceleistung:</dt>
                <dd className="uk-text-bold">{service.title}</dd>
            </dl>
            {values.serviceNotes && (
                <dl className="uk-description-list">
                    <dt>Ihre Notiz:</dt>
                    <dd style={{ whiteSpace: 'pre' }}>{values.serviceNotes}</dd>
                </dl>
            )}
        </>
    );
}

function ActiveChildren({ values, setFieldValue, handleBlur, touched, errors }) {
    const services = useSelector(dienstleistungenSelector);
    const service = useSelector(state => serviceAnfrageByServiceUrlSelector(state, { serviceUrl: values.serviceUrl }));
    const onChange = useCallback(({ name, value }) => setFieldValue(name, value), [setFieldValue]);
    const servicesOptions = useMemo(() => services.map(service => ({ label: service.title, value: service.url })), [services]);

    return (
        <>
            <Select
                label="Wählen Sie eine Service-Leistung aus."
                value={values.serviceUrl}
                onBlur={handleBlur}
                error={touched.serviceUrl && errors.serviceUrl}
                name="serviceUrl"
                options={servicesOptions}
                onChange={onChange}
            />
            <div className="uk-margin">
                <div dangerouslySetInnerHTML={{ __html: service.marketingText }} />
            </div>
            <Textarea
                onBlur={handleBlur}
                value={values.serviceNotes}
                error={touched.serviceNotes && errors.serviceNotes}
                name="serviceNotes"
                onChange={onChange}
                placeholder="Z.B. wenn Ihnen etwas aufgefallen ist am Auto, können Sie es hier notieren."
            />
        </>
    );
}

export const serviceSelectorStepFactory = ({ validServiceUrl, anfrageText = '' }) => {
    return {
        inactiveChildren: props => <InactiveChildren {...props} />,
        activeChildren: props => <ActiveChildren {...props} />,
        title: 'Service',
        initialValues: { serviceNotes: anfrageText, serviceUrl: validServiceUrl },
        validationSchema,
    };
};
